import { defineStore } from 'pinia';
import Vue from 'vue';

export const useDownloadsStore = defineStore('downloads', {
    state: () => ({
        datasetGroups: {},
        datasetTimes: {},
        errors: {}
    }),

    actions: {
        // Former mutations
        addDownloads(payload) {
            if (payload[0] && payload[1]) {
                Vue.set(this.datasetGroups, ...payload);
            }
        },
        addTimes(payload) {
            if (payload[0] && payload[1]) {
                Vue.set(this.datasetTimes, ...payload);
            }
        },
        addErrors(payload) {
            if (payload[0] && payload[1]) {
                Vue.set(this.errors, ...payload);
            }
        }
    }
});
